// extracted by mini-css-extract-plugin
export default {"showcase":"showcase__LJw7d","subtitle":"subtitle__x0069","badges":"badges__oJvfk"};